import { CommentEditIcon } from '../../Brand/Icon';
import React from "react";
import { flushSync } from 'react-dom';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTES } from '../../../utils/constant';
import { getUser } from '../../../utils/func';
import url from '../../../utils/url';
import { AnimatedLink } from '../AnimatedLink';
import { useTranslation } from 'react-i18next';

export default function ButtonReactionAdd({ storyId, story, disabled, opinionIntent }) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const user = getUser();
	const { username } = useParams();
	const editorPath = url(`${APP_ROUTES.POST}/${storyId}${APP_ROUTES.REACTION_EDIT}`);
	const preventDisabledNavigation = event => {
		if (disabled) event.preventDefault();
	};
	const openEditor = event => {
		if (disabled) { event.preventDefault(); return; }
		// Retain native link behavior for new tabs and modified clicks.
		if (event.defaultPrevented || event.button !== 0 || event.metaKey
			|| event.ctrlKey || event.shiftKey || event.altKey) return;
		event.preventDefault();
		// Mobile browsers require an editable element to receive focus during
		// this user gesture. Waiting for data, an effect or a timer loses it.
		flushSync(() => navigate(editorPath, { state: { focusComposer: true, story, opinionIntent,
			...(username && username === user?.user_name ? { profileUsername: username } : {}) } }));
		document.querySelector('.comment-editor-container .ProseMirror[contenteditable="true"]')
			?.focus({ preventScroll: true });
	};

	return (
		<span>
			{/* Keep the link/SVG mounted while a vote saves. The editor itself
			    waits for pending writes before hydrating the saved opinion. */}
			<AnimatedLink className="reaction-comment-link" aria-label={t('post.your_opinion')}
				to={disabled ? '#' : editorPath} aria-disabled={disabled || undefined}
				tabIndex={disabled ? -1 : undefined}
				onClick={openEditor} onAuxClick={preventDisabledNavigation}>
				<CommentEditIcon className='nav-icon' />
			</AnimatedLink>
		</span>
	)
}
